import type { AccountKey } from "owa-client-types";
import type { BizChatCompositeKey, MainWindowKey, WindowKey } from "owa-bizchat-types";

export function getBizChatCompositeKey(accountKey: AccountKey, windowKey: WindowKey): BizChatCompositeKey {
    return `${accountKey}_${windowKey}`;
}

export function isMainWindowKey(windowKey: WindowKey): windowKey is MainWindowKey {
    return windowKey === "SidePane" || windowKey === "Immersive";
}
